import React from 'react';
import cx from 'classnames';
import styles from './FullSection.module.css';

/**
 * Provides a full-width section to wrap children elements in.
 * Can add a background and custom styles to control the space.
 *
 * @param children
 * @param className
 * @param style
 * @returns {JSX.Element}
 */
export default ({ children, className, style }) => (
  <div className={cx(styles.fullSection, className)} style={style}>
    <div className={styles.fullSectionInner}>
      {children}
    </div>
  </div>
);
